import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Line, Pie } from 'react-chartjs-2';
import ChartJSAdapter from 'y4/adapter/ChartJSAdapter';
import { getChartByDD } from 'y4/Y4Api';

const ChartJSPanel = ({ panel }) => {
  const [option, setOption] = useState(JSON.parse(panel.chart.option));

  useEffect(() => {
    getChartByDD(panel.dataCode, panel.chart.code).then(rt => {
      if (rt.isOk()) {
        var data = rt.data;
        const new_option = JSON.parse(panel.chart.option);
        const adapt = ChartJSAdapter[new_option.name];
        if (adapt) {
          adapt({ panel, option: new_option, data });
          setOption(new_option);
        } else {
          setOption({
            error: 1,
            errorTitle: `No Adapter`,
            errorDescription: `No Adapter ${new_option.name} in ChartJSAdapter`
          });
        }
      } else {
        setOption({
          error: 1,
          errorTitle: `Error ${rt.id}` + (rt.code ? `(${rt.code})` : ''),
          errorDescription: rt.message
        });
      }
    });
  }, []);

  if (option.type == 'Pie') {
    return (
      <Pie
        data={option.data}
        options={option.options}
        height={option.height}
        width={option.width}
      />
    );
  } else if (option.type == 'Line') {
    return (
      <Line
        data={option.data}
        options={option.options}
        height={option.height}
        width={option.width}
      />
    );
  } else {
    return (
      <>
        <h5 className="mb-0 mt-1">{option.errorTitle}</h5>
        <div className="pt-3">{option.errorDescription}</div>
      </>
    );
  }
};

ChartJSPanel.propTypes = {
  panel: PropTypes.object
};

export default ChartJSPanel;
